import { createMemo } from 'solid-js'

export type CountdownParts = {
  days: number
  hours: number
  minutes: number
}

/** Pure derivation: how many whole days/hours/minutes remain between `now`
 *  and `endDate`. Clamps to zero when the deadline has passed. */
export function deriveCountdown(now: Date, endDate: Date): CountdownParts {
  const diff = Math.max(0, endDate.getTime() - now.getTime())
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
  return { days, hours, minutes }
}

export function useCountdown(params: () => { now: Date; endDate: Date }) {
  return createMemo(() => {
    const { now, endDate } = params()
    return deriveCountdown(now, endDate)
  })
}
